module.exports = __webpack_public_path__ + "img/14.64ff7ed1.gif";